import React from 'react'
import {styled, Button as MuiButton} from '@material-ui/core'
import Tooltip from '@material-ui/core/Tooltip'
import {useCurrentUser} from 'users/hooks'
import {useDispatch} from 'react-redux'
import {scheduleDemoClicked} from 'lms/store/actions'

const Button = styled(MuiButton)({})

const ScheduleDemoButton = ({calendarUrl, systemId, ...props}) => {
  const user = useCurrentUser()
  const isGuestUser = !user
  const dispatchRedux = useDispatch()

  if (!calendarUrl) return null

  const handleClick = event => {
    event.preventDefault()
    event.stopPropagation()
    if (!isGuestUser) {
      if (!/^https?:\/\//i.test(calendarUrl)) return
      if (systemId) dispatchRedux(scheduleDemoClicked(systemId))
      window.open(calendarUrl, '_blank', 'noopener,noreferrer')
    }
  }

  return (
    <Tooltip
      title='Create a FREE account to access this feature'
      disableHoverListener={!isGuestUser}
    >
      <span>
        <Button
          color='primary'
          variant='outlined'
          onClick={handleClick}
          disabled={isGuestUser}
          style={{
            color: isGuestUser ? '#D3D3D3' : '',
            border: `1px solid ${isGuestUser ? '#D3D3D3' : ''}`
          }}
          {...props}
        >
          Schedule Demo
        </Button>
      </span>
    </Tooltip>
  )
}

export default ScheduleDemoButton
